import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import i18n from './i18n'
import { auth } from './config/firebase'
import { syncAuthLanguage } from './config/authLanguage'

syncAuthLanguage(i18n, auth)

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
